import React from 'react'
import caramelmacchiatoo from './caramelmacchiatoo.png'
import dirtymatcha from './dirtymatcha.PNG'
import chocolate from './chocolate.PNG'
import strawberry from './strawberry.png'
import saltedcarmel from './saltedcarmel.png'
import cookiesncream from './cookiesncream.png'
import matcha2 from './matcha2.png'
import spanish from './spanish.png'
import okinawa from './okinawa.png'
import wintermelon from './wintermelon.png'
import passionfruit from './passionfruit.png'
import lychee from './lychee.png'
import greenapple from './greenapple.png'
import categ from './categ.png'

import qrcode from './qrcode.jpg'
import upload_area from './upload_area.png'
import parcel_icon from './parcel_icon.png'

export const images = {
    qrcode,
    upload_area,
    parcel_icon,
}

export const menu_list = [
    {
        menu_name: "Coffee",
        menu_image: categ
    },
    {
        menu_name: "Milk Tea",
        menu_image: categ
    },
    {
        menu_name: "Fruit Series",
        menu_image: categ
    }
]

export const bev_list = [
    { _id: "664cb1475af72bdd6e3b4a5c", name: "Caramel Macchiato", image: caramelmacchiatoo, sugar_level: 5 },
    { _id: "664cb1555af72bdd6e3b4a5e", name: "Chocolate", image: chocolate, sugar_level: 7 },
    { _id: "664cb15d5af72bdd6e3b4a60", name: "Cookies and Cream", image: cookiesncream, sugar_level: 9 },
    { _id: "664cb1675af72bdd6e3b4a62", name: "Dirty Matcha", image: dirtymatcha, sugar_level: 4 },
    { _id: "664cb1745af72bdd6e3b4a64", name: "Green Apple", image: greenapple, sugar_level: 4 },
    { _id: "664cb17d5af72bdd6e3b4a66", name: "Lychee", image: lychee, sugar_level: 3 },
    { _id: "664cb18d5af72bdd6e3b4a68", name: "Green Matcha", image: matcha2, sugar_level: 3 },
    { _id: "664cb1955af72bdd6e3b4a6a", name: "Okinawa", image: okinawa, sugar_level: 4 },
    { _id: "664cb1a15af72bdd6e3b4a6c", name: "Passion Fruit", image: passionfruit, sugar_level: 4 },
    { _id: "664cb1b25af72bdd6e3b4a6e", name: "Salted Caramel", image: caramelmacchiatoo, sugar_level: 5 },
    { _id: "664cb1ba5af72bdd6e3b4a70", name: "Spanish Latte", image: spanish, sugar_level: 5 },
    { _id: "664cb1c55af72bdd6e3b4a72", name: "Strawberry", image: strawberry, sugar_level: 4 },
    { _id: "664cb1ce5af72bdd6e3b4a74", name: "Wintermelon", image: wintermelon, sugar_level: 4 },
]



export const price_list = [
    { _id: "664cb1475af72bdd6e3b4a5c", size: "16oz", price: 39, size2: "22oz", price2: 49 },
    { _id: "664cb1555af72bdd6e3b4a5e", size: "16oz", price: 39, size2: "22oz", price2: 49 },
    { _id: "664cb15d5af72bdd6e3b4a60", size: "16oz", price: 39, size2: "22oz", price2: 49 },
    { _id: "664cb1675af72bdd6e3b4a62", size: "16oz", price: 39, size2: "22oz", price2: 49 },
    { _id: "664cb1745af72bdd6e3b4a64", size: "16oz", price: 39, size2: "22oz", price2: 49 },
    { _id: "664cb17d5af72bdd6e3b4a66", size: "16oz", price: 39, size2: "22oz", price2: 49 },
    { _id: "664cb18d5af72bdd6e3b4a68", size: "16oz", price: 39, size2: "22oz", price2: 49 },
    { _id: "664cb1955af72bdd6e3b4a6a", size: "16oz", price: 39, size2: "22oz", price2: 49 },
    { _id: "664cb1a15af72bdd6e3b4a6c", size: "16oz", price: 39, size2: "22oz", price2: 49 },
    { _id: "664cb1b25af72bdd6e3b4a6e", size: "16oz", price: 39, size2: "22oz", price2: 49 },
    { _id: "664cb1ba5af72bdd6e3b4a70", size: "16oz", price: 39, size2: "22oz", price2: 49 },
    { _id: "664cb1c55af72bdd6e3b4a72", size: "16oz", price: 39, size2: "22oz", price2: 49 },
    { _id: "664cb1ce5af72bdd6e3b4a74", size: "16oz", price: 39, size2: "22oz", price2: 49 },
]


export const addson_list = [
    {
        _id: "1",
        name: "Coffee Jelly"
    }, {
        _id: "2",
        name: "Espresso"
    }, {
        _id: "3",
        name: "Nata"
    }, {
        _id: "4",
        name: "Pearl"
    }
]